export default function() {
    return {
        cloudProxy: "",
        upcomingEvents: null,
        eventDetails: {},
        meetingJoined: false,
        dominantSpeaker: null,
        forceLeave: false,
        ongoingSession: false,
        ongoingSessionID: "",
        eventSlotFirebase: null,
        showAvSettingsModal: false,
        showTurboBridgeModal: false,
        showSurveyPopupModal: false,
        currentBandwidth: null,
        currentVideoSettings: "video_high",
        currentSessionJoinTime: null
            // currentVideoSettings: "video_off"
    }
}